import { Stack } from "@mui/material"

import { EditorView } from "@codemirror/view"
import CodeMirror from "@uiw/react-codemirror"
import useEditorSettings from "hooks/useEditorSettings"
import usePrettier from "hooks/usePrettier"

const CMEditor = ({
  onChange,
  moreExtensions,
  showSnippetCard,
  style,
  snippetId,
  body,
  editable,
}) => {
  const {
    basicSetup,
    extensions,
    currentThemeObj,
    fullscreen,
    type,
  } = useEditorSettings({
    id: snippetId,
  })
  const [, error] = usePrettier(body || "", type)

  const updateToMinNumberOfLines = (ViewUpdate, minNumOfLines) => {
    const currentNumOfLines = ViewUpdate.state.doc.lines
    const currentStr = ViewUpdate.state.doc.toString()
    if (currentNumOfLines >= minNumOfLines) {
      return
    }
    const lines = minNumOfLines - currentNumOfLines
    const appendLines = "\n".repeat(lines)
    ViewUpdate.view.dispatch(
      ViewUpdate.state.update({
        changes: { from: currentStr.length, insert: appendLines },
      })
    )
  }

  return (
    <Stack
      position="relative"
      sx={{
        // minHeight: `${Number(height)}px`,
        "& .cm-scroller": {
          overflowX: showSnippetCard ? "auto !important" : "hidden",
        },
      }}
      className="cm-editor cm-test"
    >
      <CodeMirror
        theme={currentThemeObj}
        extensions={[extensions, ...moreExtensions]}
        value={body || ""}
        basicSetup={{
          ...basicSetup,
          history: true,
          bracketMatching: true,
          autocompletion: true,
          closeBrackets: true,
          closeBracketsKeymap: true,
          defaultKeymap: true,
          completionKeymap: true,
          crosshairCursor: true,
          allowMultipleSelections: true,
          drawSelection: true,
          historyKeymap: true,
          indentOnInput: true,
          lintKeymap: true,
          rectangularSelection: true,
          syntaxHighlighting: true,
          searchKeymap: true,
          dropCursor: false,
          scrollPastEnd: false,
        }}
        editable={editable}
        style={{
          height: fullscreen ? "100vh" : "auto",
        }}
        onChange={onChange}
        className="cm-editor"
        onUpdate={(ViewUpdate) => {
          updateToMinNumberOfLines(ViewUpdate, fullscreen ? 50 : 10)
        }}
      />
      {error && type ? (
        <CodeMirror
          value={error.message}
          theme={"dark"}
          basicSetup={{ lineNumbers: false, foldGutter: false }}
          extensions={[
            EditorView.editable.of(false),
            EditorView.theme({
              ".cm-content": {
                color: "red",
                backgroundColor: "#121212",
                fontSize: "1.2rem",
              },
            }),
          ]}
          style={{ ...style }}
        />
      ) : null}
    </Stack>
  )
}
export default CMEditor
